import { parse } from "node-html-parser";

/**
 * Strips tags from an html string.
 *
 * @param htmlText
 */
export function stripTags (htmlText: string) {
  return parse(htmlText ?? "").rawText;
}